import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="text-center">
        <h1 className="text-4xl md:text-6xl font-bold mb-4 text-foreground">404</h1>
        <p className="text-lg md:text-xl text-muted-foreground mb-4">Oops! Page not found</p>
        <a 
          href="/" 
          className="inline-block bg-primary text-primary-foreground px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors min-h-[44px] touch-none"
        >
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
